import { dailyContest, videoArticles } from '@/mocks/homeData';
import ArticleCard from '@/components/base/ArticleCard';

export default function DailySection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-10 md:mb-14 gap-4">
            <div>
              <p className="text-sm font-medium text-accent-700 uppercase tracking-wider mb-1">
                🔥 每日更新
              </p>
              <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 italic">
                每日大赛不打烊
              </h2>
            </div>
            <div className="max-w-md">
              <p className="text-sm text-foreground-600 leading-relaxed">
                每日精选最劲爆的爆料内容，实时追踪网络热议事件，让你永远站在吃瓜第一线。黑料不停更，吃瓜不打烊。
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {dailyContest.map((article) => (
              <div key={article.id} className="relative">
                <ArticleCard
                  title={article.title}
                  category={`${article.hotLevel} · 每日大赛`}
                  categorySlug="dasai"
                  date={article.date}
                  image={article.image}
                  slug={article.slug}
                />
              </div>
            ))}
          </div>

          <div className="mt-16 md:mt-20">
            <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-10 gap-4">
              <div>
                <p className="text-sm font-medium text-foreground-400 uppercase tracking-wider mb-1">
                  独家视频
                </p>
                <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 italic">
                  吃瓜视频精选
                </h2>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
              {videoArticles.map((article, index) => (
                <ArticleCard
                  key={article.id}
                  title={article.title}
                  category={article.category}
                  categorySlug={article.categorySlug}
                  date={article.date}
                  image={article.image}
                  slug={article.slug}
                  variant={index === 0 ? 'accent' : 'default'}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}